<swiper-container
  autoplay="true"
  autoplay-delay="5000"
  loop="true"
  #swiper
  slides-per-view="1"
>
  <swiper-slide lazy="false">
    <app-home-carousel-item2></app-home-carousel-item2>
  </swiper-slide>
  <swiper-slide lazy="false">
    <app-home-carousel-item1></app-home-carousel-item1>
  </swiper-slide>
</swiper-container>
<mat-icon
  class="prev"
  fontSet="material-symbols-outlined"
  inline
  (click)="swiper.swiper.slidePrev()"
  >chevron_left</mat-icon
>
<mat-icon
  class="next"
  fontSet="material-symbols-outlined"
  inline
  (click)="swiper.swiper.slideNext()"
  >chevron_right</mat-icon
>
